module.exports = __webpack_public_path__ + "static/media/placeholder.7554dc4a.svg";